export const DispatchEvent = {
  mounted() {
    window.addEventListener('phx:mailroom:dispatch-event', (event) => {
      if (event.detail.to == null) {
        this.pushEvent(event.detail.event, event.detail.payload, (reply, ref) => {});
      } else {
        this.pushEventTo(event.detail.to, event.detail.event, event.detail.payload, (reply, ref) => {});
      }
    });
  },
};
